import { render } from "./SingleChat.vue?vue&type=template&id=4fcfc15f"
import script from "./SingleChat.vue?vue&type=script&lang=js"
export * from "./SingleChat.vue?vue&type=script&lang=js"

import "./SingleChat.vue?vue&type=style&index=0&id=4fcfc15f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__